window.VegasCatalog.Promocode = {
	check: function (code, callback) {
		var params = {
			promocode: code
		};

		$.get('/cart/promocode_check', params, function (data) {
			if (callback) {
				callback(data);
			}
		});
	},

	activate: function (code, callback) {
		var params = {
			promocode: code
		};

		$.get('/cart/promocode_activate', params, function (data) {
			if (callback) {
				callback(data);
			}
		});
	},

	deactivate: function (callback) {
		$.get('/cart/promocode_deactivate', {}, function (data) {
			if (callback) {
				callback(data);
			}
		});
	},
};

$(document).ready(function() {
	$(document).on('input', '.vg-catalog-cart--promocode [name=promocode]', function () {
		let $self = $(this);
		let $container = $(this).closest('.vg-catalog-cart--promocode');
		let $result = $container.find('.col-result');

		let promocode = $(this).val();

		if (promocode) {
			VegasCatalog.Promocode.check(promocode, function (data) {
				$result.find('.error-block, .success-block, .question-block').hide();

				if (data.error) {
					let $s = $result.find('.error-block');
					$s.find('.text').text(data.msg);
					$s.show();
				} else {
					let $s = $result.find('.question-block');
					$s.find('.text').html('Скидка по промокоду: ' + data.discount);
					$s.show();
				}

				$result.show();
			});
		} else {
			$result.hide();
		}
	});

	$(document).on('click', '.vg-catalog-cart--promocode .btn-activate-promocode', function () {
		let $container = $(this).closest('.vg-catalog-cart--promocode');
		let $result = $container.find('.col-result');
		let $input = $container.find('[name=promocode]');
		let promocode = $input.val();

		VegasCatalog.Promocode.activate(promocode, function (data) {
			$input.attr('readonly', true);
			VegasCatalog.Cart.total(data.totals);
			VegasCatalog.Cart.updateTotalAll();

			$result.find('.error-block, .success-block, .question-block').hide();
			let $s = $result.find('.success-block');
			$s.find('.text').html('Промокод активирован<br>Скидка: ' + output_money(data.totals.sums.sum_promocode));
			$s.show();
		});

		return false;
	});

	$(document).on('click', '.vg-catalog-cart--promocode .btn-deactivate-promocode', function () {
		let $container = $(this).closest('.vg-catalog-cart--promocode');
		let $result = $container.find('.col-result');
		let $input = $container.find('[name=promocode]');

		VegasCatalog.Promocode.deactivate(function (data) {
			$input.val('').removeAttr('readonly');
			VegasCatalog.Cart.total(data.totals);
			VegasCatalog.Cart.updateTotalAll();
			$result.hide();
		});

		return false;
	});
});
